<script setup>
// A minimal loading status line shared by the auth callback and logout screens
// (#2230). Deliberately quiet: just a spinner and a headline, matching the
// simplified login screen. The flow's detail lives in logs and the error card,
// not in an on-screen checklist.
defineProps({
    // Headline, e.g. "Signing you in".
    label: { type: String, required: true },
    // Work still in flight: drives the spinner. Pass false once the flow has
    // settled (done or failed).
    busy: { type: Boolean, default: true }
});
</script>

<template>
    <div class="con-load">
        <div class="con-load-row">
            <span v-if="busy" class="con-spin"></span>
            <span>{{ label }}</span>
        </div>
    </div>
</template>
